import { Collection } from 'modules/core/lib/mobx-rest'

import CalendarDay from 'modules/attendance/store/models/CalendarDay'

class Calendar extends Collection<CalendarDay> {
  get cacheKey(): string {
    return 'calendar'
  }

  model() {
    return CalendarDay
  }
}

const singleton: Calendar = new Calendar()

export { Calendar }

export default singleton
